import * as React from "react";
import { useForm } from "../../../../hooks/use_form_v2";
import { Form } from "../../../Components/Form/Form/Form";
import { AutomationType, automationTypes, IAutomation } from "../../../../config/automation";
import { SelectField } from "../../../Components/Form/SelectField";
import { UserPaymentMethodForm } from "./UserPaymentMethod/UserPaymentMethodForm";
import { CategoryForm } from "./Category/CategoryForm";
import { useModal } from "../../../../hooks/use_modal";
import { FormModal } from "../../../Components/FormModal";
import { validateAutomationForm } from "../../../../validators/automations";

export enum AutomationFormScope {
    CREATE,
    UPDATE,
}

interface IAutomationFormProps {
    scope: AutomationFormScope;
    title: string;
    trigger: React.JSX.Element;
    onSave(value: any): Promise<IAutomation>;
    value?: any;
}

export interface IAutomationFormState {
    type: AutomationType;
    value: any; // todo refactor it
}

export const AutomationForm = ({scope, trigger, title, value, onSave}: IAutomationFormProps) => {
    const { open, handleModalOpen, handleModalClose } = useModal();

    const form = useForm<IAutomationFormState>(value || {});
    const { errors, register, reset, watch } = form;

    const handleClose = () => {
        handleModalClose();

        if (scope === AutomationFormScope.CREATE) {
            setTimeout(() => {
                reset();
            }, 250);
        }
    };

    const handelSubmit = (values: IAutomationFormState) => {
        const validation = validateAutomationForm(values);
        if (!validation.isValid()) {
            return Promise.reject(validation);
        }

        return onSave(values).then(() => {
            handleClose();
        });
    };

    return (
        <>
            {React.cloneElement(trigger, { onClick: handleModalOpen } as any)}

            <FormModal open={open} title={title} onClose={handleClose}>
                <Form form={form} onSubmit={handelSubmit}>
                    <Form.Field type={SelectField} options={automationTypes} {...register('type')} />

                    <Form.Field
                        type={UserPaymentMethodForm}
                        {...register('value')}
                        errors={errors}
                        conditional={watch('type') === AutomationType.PAYMENT_METHOD}
                    />
                    <Form.Field
                        type={CategoryForm}
                        {...register('value')}
                        errors={errors}
                        conditional={watch('type') === AutomationType.CATEGORY}
                    />
                </Form>
            </FormModal>
        </>
    );
}
